import { Application, Container } from 'pixi.js';
import type { Ticker } from 'pixi.js';
import { PAPER } from './color';

export interface Stage {
  app: Application;
  canvas: Application['canvas'];
  ticker: Ticker;
  back: Container;
  world: Container;
  width: number;
  height: number;
  destroy(): void;
}

export async function createStage(mount: HTMLElement, background = PAPER): Promise<Stage> {
  const app = new Application();
  await app.init({
    background,
    resizeTo: mount,
    antialias: true,
    preference: 'webgl',
    resolution: Math.min(window.devicePixelRatio, 2),
    autoDensity: true,
  });
  mount.appendChild(app.canvas);

  const back = new Container({ label: 'back', zIndex: 0 });
  const world = new Container({ label: 'world', zIndex: 10 });
  app.stage.sortableChildren = true;
  app.stage.addChild(back, world);
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(() => app.resize()) : null;

  const stage: Stage = {
    app,
    canvas: app.canvas,
    ticker: app.ticker,
    back,
    world,
    width: app.screen.width,
    height: app.screen.height,
    destroy() {
      observer?.disconnect();
      app.destroy(true, { children: true });
    },
  };

  app.renderer.on('resize', () => {
    stage.width = app.screen.width;
    stage.height = app.screen.height;
  });
  observer?.observe(mount);

  return stage;
}
